import { render, staticRenderFns } from "./OperaUserWindow.vue?vue&type=template&id=2ae0ad08&scoped=true"
import script from "./OperaUserWindow.vue?vue&type=script&lang=js"
export * from "./OperaUserWindow.vue?vue&type=script&lang=js"
import style0 from "./OperaUserWindow.vue?vue&type=style&index=0&id=2ae0ad08&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ae0ad08",
  null
  
)

export default component.exports